import { useEffect } from 'react';
import axios from 'axios';
import { getBaseURL } from '../services/api';

// axios direto pra endpoint publico (sem token) — track e anonimo.
function post(payload) {
  return axios.post(`${getBaseURL()}/lp/track`, payload).catch(() => {});
}

// Registra 1 view por mount (sem dedup por sessao).
export function useTrackLPView(path) {
  useEffect(() => {
    if (!path) return;
    post({ path, event_type: 'view' });
  }, [path]);
}

// Chamar dentro de onClick de CTAs. label identifica qual botao.
export function trackLPClick(path, label) {
  return post({ path, event_type: 'cta_click', cta_label: label });
}
